"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const material_1 = require("@mui/material");
const react_1 = require("react");
const fontawesome_icon_1 = require("./fontawesome-icon");
/**
 * @todo add custom class for component so it's easier to target the component using css
 */
const Select = ({ children, sx = [], selectSx = [], error, helperText, label, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: sx, children: [label && ((0, jsx_runtime_1.jsx)(material_1.InputLabel, { ...(props.labelId && { id: props.labelId }), children: label })), (0, jsx_runtime_1.jsx)(material_1.Select, { fullWidth: true, sx: [
                    ({ palette }) => ({
                        ...(error && {
                            [`.${material_1.outlinedInputClasses.notchedOutline}`]: {
                                borderColor: `${palette.orange[50]} !important`,
                            },
                        }),
                    }),
                    ...(Array.isArray(selectSx) ? selectSx : [selectSx]),
                ], ...props, ref: ref, children: children }), (0, jsx_runtime_1.jsx)(material_1.Collapse, { in: !!helperText, children: (0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { error: true, sx: { display: "flex", alignItems: "center", mt: 1 }, children: [(0, jsx_runtime_1.jsx)(fontawesome_icon_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleExclamation }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallTextLabels", children: helperText })] }) })] }));
};
// used the type assertion approach in https://stackoverflow.com/a/58473012
const SelectForwardRef = (0, react_1.forwardRef)(Select);
exports.Select = SelectForwardRef;
